module.exports = __webpack_public_path__ + "img/12加入我们-img1.69cc902a.jpg";